import React from "react";
import Header from "../components/Header"; // ✅ Certifique-se de que o caminho está correto

import "../styles/LegalPages.css";

const PrivacyPolicy = () => {
  return (

    <>
      <Header /> {/* ✅ Aqui o Header será exibido no topo da página */}


    <div className="legal-container">
      <h1>Política de Privacidade</h1>
      <p>Última atualização: 13 de fevereiro de 2025</p>

      <section>
        <h2>1. Introdução</h2>
        <p>
          Bem-vindo ao <strong>RondaGO</strong>. A sua privacidade e a proteção dos seus dados pessoais são fundamentais para nós.
          Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações ao utilizar nossos serviços.
          Ao acessar ou utilizar o RondaGO, você concorda com as práticas descritas neste documento.
        </p>
      </section>

      <section>
        <h2>2. Informações Coletadas</h2>
        <p>
          Coletamos diferentes tipos de informações para fornecer e aprimorar nossos serviços, incluindo:
        </p>
        <ul>
          <li><strong>Dados Pessoais:</strong> Nome, e-mail, telefone, CPF/CNPJ (se aplicável) e outras informações fornecidas voluntariamente pelo usuário.</li>
          <li><strong>Dados de Uso:</strong> Informações sobre como você interage com nossa plataforma, incluindo páginas acessadas, tempo de uso e preferências.</li>
          <li><strong>Cookies e Tecnologias de Rastreamento:</strong> Utilizamos cookies e tecnologias similares para otimizar a experiência do usuário e realizar análises estatísticas.</li>
        </ul>
      </section>

      <section>
        <h2>3. Finalidade do Uso dos Dados</h2>
        <p>As informações coletadas são utilizadas para os seguintes propósitos:</p>
        <ul>
          <li>Fornecer e melhorar a experiência dos usuários na plataforma.</li>
          <li>Personalizar o conteúdo e recomendações com base no comportamento do usuário.</li>
          <li>Enviar comunicações institucionais, promocionais ou operacionais, desde que autorizadas.</li>
          <li>Garantir a segurança dos usuários e prevenir fraudes.</li>
          <li>Atender a obrigações legais e regulatórias.</li>
        </ul>
      </section>

      <section>
        <h2>4. Compartilhamento de Dados</h2>
        <p>
          O RondaGO não vende nem comercializa seus dados pessoais. No entanto, podemos compartilhar informações nas seguintes situações:
        </p>
        <ul>
          <li>Com prestadores de serviço e parceiros que auxiliam na operação da plataforma, como processadores de pagamento e serviços de hospedagem.</li>
          <li>Para cumprimento de exigências legais, regulatórias ou solicitações governamentais.</li>
          <li>Em caso de fusão, aquisição ou venda de ativos, mediante notificação prévia aos usuários.</li>
        </ul>
      </section>

      <section>
        <h2>5. Segurança e Proteção dos Dados</h2>
        <p>
          Implementamos medidas de segurança técnicas e organizacionais para proteger as informações dos usuários contra acessos não autorizados, 
          uso indevido, perda, destruição ou alteração. No entanto, nenhuma plataforma é totalmente imune a riscos, e recomendamos que os usuários 
          adotem boas práticas de segurança, como o uso de senhas fortes e não compartilhamento de credenciais.
        </p>
      </section>

      <section>
        <h2>6. Direitos do Usuário</h2>
        <p>
          Conforme a legislação aplicável, incluindo a Lei Geral de Proteção de Dados (LGPD), você tem direito a:
        </p>
        <ul>
          <li>Acessar seus dados pessoais armazenados na plataforma.</li>
          <li>Corrigir informações imprecisas ou incompletas.</li>
          <li>Solicitar a exclusão de seus dados, respeitadas as obrigações legais.</li>
          <li>Revogar o consentimento para o uso de determinadas informações.</li>
          <li>Solicitar a portabilidade de seus dados para outro serviço, quando aplicável.</li>
        </ul>
        <p>
          Para exercer seus direitos, entre em contato pelo e-mail: <a href="mailto:contato@rondago.com.br">contato@rondago.com.br</a>
        </p>
      </section>

      <section>
        <h2>7. Retenção dos Dados</h2>
        <p>
          Os dados coletados serão armazenados pelo tempo necessário para cumprir as finalidades para as quais foram coletados ou conforme exigido por lei. 
          Após esse período, os dados serão anonimizados ou excluídos de forma segura.
        </p>
      </section>

      <section>
        <h2>8. Atualizações na Política de Privacidade</h2>
        <p>
          Podemos atualizar esta Política de Privacidade periodicamente para refletir mudanças em nossas práticas ou requisitos legais.
          Os usuários serão notificados sobre alterações significativas. O uso contínuo do RondaGO após a publicação das alterações será considerado como aceitação das novas diretrizes.
        </p>
      </section>

      <section>
        <h2>9. Contato</h2>
        <p>
          Caso tenha dúvidas ou precise de mais informações sobre a nossa Política de Privacidade, entre em contato pelo e-mail: 
          <a href="mailto:contato@rondago.com.br">contato@rondago.com.br</a>
        </p>
      </section>
    </div>
        </>

  );
};

export default PrivacyPolicy;
